var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.Sampling.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.Sampling.text,
      "bgImage": "/images/sub/product/sampling-bg.jpg",
      "image": "/images/sub/product/sampling-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Our Sampling System is designed to provide the highest level of performance and accuracy, ensuring that your samples are prepared and analyzed to the highest standard. Whether you need to meet strict regulatory requirements or need to handle complex samples, our sample handling system can be customized to meet your specific needs and deliver the results you need. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" In addition, the system can be integrated with a variety of online analyzers, including mass spectrometers, gas chromatographs, and other analytical instruments. This allows for seamless sample preparation and analysis, resulting in high-quality data and accurate results. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }